module.exports = __webpack_public_path__ + "img/37108be.png";